import React, { useState, useEffect } from "react";
import ReportFilter from "../../components/Filter/ReportFilter";
import Table, { renderCellExpand } from '../../components/Table/Table';
import { fetchAPIData, generateHiddenColumns, getCompanyId } from '../../Utils/Common';
import Divider from '@mui/material/Divider';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import sharedContext from "../../contexts/shared-context";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import "./documents.scss";

const processReportsSchemaView = require("../../json/reportsSchema.json").view.process;
const workflowReportsSchemaView = require("../../json/reportsSchema.json").view.workflow;
const classificationReportsSchemaView = require("../../json/reportsSchema.json").view.classification;
const envisionReportsSchemaView = require("../../json/reportsSchema.json").view.envision;
const coreReportsSchemaView = require("../../json/reportsSchema.json").view.core;

const DocumentReportTabPanel = ({ setNotify }) => {

    const [processReportApiData, setprocessReportApiData] = useState([]);
    const [workflowReportApiData, setworkflowReportApiData] = useState([]);
    const [classificationReportApiData, setclassificationReportApiData] = useState([]);
    const [enVisionReportApiData, setEnvisionReportApiData] = useState([]);
    const [coreReportApiData, setCoreReportApiData] = useState([]);
    const [reportType, setReportType] = useState('process');
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    // get company id from header using sharedcontext
    const globalCompanyId = React.useContext(sharedContext);

    const [reportsProcess, setProcess] = usePersistentStorage("reportsProcess", []);
    const [reportsWorkflow, setWorkflow] = usePersistentStorage("reportsWorkflow", []);
    const [reportsClassification, setClassification] = usePersistentStorage("reportsClassification", []);
    const [reportsEnvision, setEnvision] = usePersistentStorage("reportsEnvision", []);
    const [coreProcess, setCoreProcess] = usePersistentStorage("coreProcess", []);
    const [isLoading, setIsloading] = useState(false);
    useEffect(() => {
        // check if localstorge had data for the current tab
        if (reportType === 'process') {
            setprocessReportApiData(reportsProcess);
        }
        if (reportType === 'workflow') {
            setworkflowReportApiData(reportsWorkflow)
        }
        if (reportType === 'classification') {
            setclassificationReportApiData(reportsClassification);
        }
        if (reportType === 'enVision') {
            setEnvisionReportApiData(reportsEnvision);
        }
        if (reportType === 'core') {
            setCoreReportApiData(coreProcess);
        }

    }, []);

    const DEFAULT_COMPANY_ID = getCompanyId(); // make company dynamic

    const COMPANY_ID = globalCompanyId && globalCompanyId !== "" ? globalCompanyId : DEFAULT_COMPANY_ID;

    const processReportApiURL = `/api/companies/${COMPANY_ID}/documents/process/report?`;

    const workflowReportApiURL = `api/companies/${COMPANY_ID}/documents/workflow/report?`;

    const classificationReportApiURL = `api/companies/${COMPANY_ID}/documents/classification/report?`;

    const enVisionReportApiURL = `/api/companies/${COMPANY_ID}/evDocuments/process/report?`;

    const coreReportApiURL = `/api/companies/${COMPANY_ID}/documents/core/report?`;

    const getTotalProcessReports = (params) => {
        return (params.row.countCSPError + params.row.countProcessError + params.row.countProcessed + params.row.countInProcess + params.row.countDocumentUploaded + params.row.countDocumentDeleted);
    };

    const getTotalWorkflowReports = (params) => {
        return (params.row.countWorkflowInit + params.row.countWorkflowCSPError + params.row.countWorkflowProcessError + params.row.countWorkflowProcessed + params.row.countWorkflowInProcess + params.row.countWorkflowDeleted);
    };

    const getTotalClassificationReports = (params) => {
        return (params.row.countClassificationCSPError + params.row.countClassificationProcessError + params.row.countClassificationProcessed + params.row.countClassificationInProcess + params.row.countClassificationUploaded + params.row.countClassificationDeleted);
    };

    const getTotalEnvisionReports = (params) => {
        return (params.row.countInternalError + params.row.countProcessError + params.row.countProcessed + params.row.countInProcess + params.row.countDocumentUploaded + params.row.countDocumentDeleted);
    };

    const getTotalCoreReports = (params) => {
        return (params.row.countProcessError + params.row.countProcessed + params.row.countInProcess + params.row.countDocumentUploaded + params.row.countDocumentDeleted);
    };


    const getReportSchema = (reportType) => {
        if (reportType === 'process') {
            return processReportsSchemaView;
        }
        else if (reportType === 'workflow') {
            return workflowReportsSchemaView
        }
        else if (reportType === 'classification') {
            return classificationReportsSchemaView;
        }
        else if (reportType === 'enVision') {
            return envisionReportsSchemaView;
        }
        else if (reportType === 'core') {
            return coreReportsSchemaView;
        }
        else {
            console.log("unknown report type: ", reportType);
        }
    };

    const processReportColumns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'companyId',
            headerName: 'Company ID',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'companyName',
            headerName: 'Company Name',
            hideable:false,
            type: 'string',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'reportDateTag',
            headerName: 'Report Date',
            hideable:false,
            //type: 'date',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'countDocumentUploaded',
            headerName: 'Documents Uploaded',
            hideable:false,
            type: 'number',
            minWidth: 160,
            maxWidth: 160,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'countInProcess',
            headerName: 'In Process',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'countProcessed',
            headerName: 'Processed',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'countDocumentDeleted',
            headerName: 'Documents Deleted',
            hideable:false,
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'countProcessError',
            headerName: 'Process Error',
            hideable:false,
            type: 'number',
            minWidth: 125,
            maxWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'countCSPError',
            headerName: 'CSP Error',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'total',
            headerName: 'Total',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: getTotalProcessReports,
        },
        {
            field: 'calculateDate',
            headerName: 'Calculated Date',
            hideable:false,
            // type: 'date',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];


    const workflowReportColumns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'companyName',
            headerName: 'Company Name',
            type: 'string',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            hideable:false,
            field: 'reportDateTag',
            headerName: 'Report Date',
            // type: 'date',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'countWorkflowInit',
            headerName: 'Workflow Init',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'countWorkflowInProcess',
            headerName: 'Workflow In Process',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'countWorkflowProcessed',
            headerName: 'Workflow Processed',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'countWorkflowDeleted',
            headerName: 'Workflow Deleted',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'countWorkflowProcessError',
            headerName: 'Workflow Process Error',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'countWorkflowCSPError',
            headerName: 'Workflow CSP Error',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'total',
            headerName: 'Total',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: getTotalWorkflowReports,
        },
        {
            hideable:false,
            field: 'calculateDate',
            headerName: 'Calculated Date',
            // type: 'date',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];

    const classificationReportColumns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'companyName',
            headerName: 'Company Name',
            type: 'string',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            hideable:false,
            field: 'reportDateTag',
            headerName: 'Report Date',
            // type: 'date',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'countClassificationUploaded',
            headerName: 'Documents Uploaded',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countClassificationInProcess',
            headerName: 'In Process',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countClassificationProcessed',
            headerName: 'Processed',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countClassificationDeleted',
            headerName: 'Documents Deleted',
            type: 'number',
            minWidth: 160,
            maxWidth: 160,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countClassificationProcessError',
            headerName: 'Process Error',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countClassificationCSPError',
            headerName: 'CSP Error',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'total',
            headerName: 'Total',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: getTotalClassificationReports,
        },
        {
            hideable:false,
            field: 'calculateDate',
            headerName: 'Calculated Date',
            // type: 'date',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];

    const envisionReportColumns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'companyName',
            headerName: 'Company Name',
            type: 'string',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            hideable:false,
            field: 'reportDateTag',
            headerName: 'Report Date',
            // type: 'date',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'countDocumentUploaded',
            headerName: 'Documents Uploaded',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countInProcess',
            headerName: 'In Process',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countProcessed',
            headerName: 'Processed',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countDocumentDeleted',
            headerName: 'Documents Deleted',
            type: 'number',
            minWidth: 160,
            maxWidth: 160,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countProcessError',
            headerName: 'Process Error',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countInternalError',
            headerName: 'Internal Error',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'total',
            headerName: 'Total',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: getTotalEnvisionReports,
        },
        {
            hideable:false,
            field: 'calculateDate',
            headerName: 'Calculated Date',
            // type: 'date',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];

    // replace column with actual values

    const coreReportColumns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'companyName',
            headerName: 'Company Name',
            type: 'string',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            hideable:false,
            field: 'createdUserId',
            headerName: 'Created User Id',
            type: 'string',
            minWidth: 150,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'reportDateTag',
            headerName: 'Report Date',
            // type: 'date',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'countDocumentCreated',
            headerName: 'Documents Created',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countDocumentUploaded',
            headerName: 'Documents Uploaded',
            type: 'number',
            minWidth: 170,
            maxWidth: 170,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countInProcess',
            headerName: 'In Process',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countProcessed',
            headerName: 'Processed',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countDocumentDeleted',
            headerName: 'Documents Deleted',
            type: 'number',
            minWidth: 160,
            maxWidth: 160,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        {
            hideable:false,
            field: 'countProcessError',
            headerName: 'Process Error',
            type: 'number',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        },
        // {
        //     field: 'countCSPError',
        //     headerName: 'Count CSP Error',
        //     type: 'number',
        //     minWidth: 150,
        //     maxWidth: 150,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left'
        // },
        {
            hideable:false,
            field: 'total',
            headerName: 'Total',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: getTotalCoreReports,
        },
        {
            hideable:false,
            field: 'calculateDate',
            headerName: 'Calculated Date',
            // type: 'date',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        }
    ];

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating document report table data: ", data);
                setIsloading(false);
                if (reportType === 'process') {
                    setprocessReportApiData(data);
                    setProcess(data);
                } else if (reportType === 'workflow') {
                    setworkflowReportApiData(data);
                    setWorkflow(data);
                } else if (reportType === 'classification') {
                    setclassificationReportApiData(data);
                    setClassification(data);
                } else if (reportType === 'enVision') {
                    setEnvisionReportApiData(data);
                    setEnvision(data);
                } else if (reportType === 'core') {
                    setCoreReportApiData(data);
                    setCoreProcess(data);
                }
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load document ${reportType} report data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                if (reportType === 'process') {
                    setprocessReportApiData([]);
                } else if (reportType === 'workflow') {
                    setworkflowReportApiData([]);
                } else if (reportType === 'classification') {
                    setclassificationReportApiData([]);
                } else if (reportType === 'enVision') {
                    setEnvisionReportApiData([]);
                } else if (reportType === 'core') {
                    setCoreReportApiData([]);
                }

                // clear the loading indicator
                setIsloading(false);

            });
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div id="reportDocumentfilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }} >
                <ReportFilter
                    reportType={reportType}
                    setReportType={setReportType}
                    processReportApiURL={processReportApiURL}
                    workflowReportApiURL={workflowReportApiURL}
                    classificationReportApiURL={classificationReportApiURL}
                    envisionReportApiURL={enVisionReportApiURL}
                    coreReportApiURL={coreReportApiURL}
                    fetchData={fetchData}
                    setNotify={setNotify} />
            </div>


            <Divider />

            {reportType === 'process' &&
                <div id="reportProcessDocumentTableContainer">
                    <div >
                        <Table data={processReportApiData} columns={processReportColumns} hiddenColumns={generateHiddenColumns(processReportColumns)} viewRowData={viewRowData} isLoading={isLoading} />
                    </div>
                </div>
            }

            {reportType === 'workflow' &&
                <div id="reportWorkflowDocumentTableContainer" >
                    <div >
                        <Table data={workflowReportApiData} columns={workflowReportColumns} hiddenColumns={generateHiddenColumns(workflowReportColumns)} viewRowData={viewRowData} isLoading={isLoading} />
                    </div>
                </div>
            }

            {reportType === 'classification' &&
                <div id="reportClassificationDocumentTableContainer">
                    <div >
                        <Table data={classificationReportApiData} columns={classificationReportColumns} hiddenColumns={generateHiddenColumns(classificationReportColumns)} viewRowData={viewRowData} isLoading={isLoading} />
                    </div>
                </div>
            }

            {reportType === 'enVision' &&
                <div id="reportEnvisionDocumentTableContainer">
                    <div >
                        <Table data={enVisionReportApiData} columns={envisionReportColumns} hiddenColumns={generateHiddenColumns(envisionReportColumns)} viewRowData={viewRowData} isLoading={isLoading} />
                    </div>
                </div>
            }

            {reportType === 'core' && 
                <div id="reportCoreDocumentTableContainer">
                    <div >
                        <Table data={coreReportApiData} columns={coreReportColumns} hiddenColumns={generateHiddenColumns(coreReportColumns)} viewRowData={viewRowData} isLoading={isLoading} />
                    </div>
                </div>
            }

            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                title={`${reportType} Report Information`}
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={`${reportType}ReportsDialogId`}
                        readOnly={true}
                        schema={getReportSchema(reportType)}
                        formData={rowJsonData}
                    />
                }
                jsonDataName={`${reportType} reports`}
                JSONTabContent={rowJsonData}
            />

        </>
    );
}

export default DocumentReportTabPanel;